/* ©2018 EdgeVerve Systems Limited (a fully owned Infosys subsidiary),
Bangalore, India. All Rights Reserved.
 */
import './currency-formator-behaviour.js';

	window.corpBehaviours = window.corpBehaviours || {};
	corpBehaviours.appFormatBehaviour ={
		properties: {
		},
		
		//function to format Amount & Currency
		formatCurrency: function (amt, sym) {
			if (amt && sym) {
				return this._symbolizeCurrency(sym + ' ' + amt);
			}
			return '';
		},
		
		//function to mask AccountID
		maskAccount: function(accID) {
			if (accID) {
				return maskAccount.accountFormat(accID);
			}
			return '';

		},
		formatDate: function(date) {
			this.dateFormat = clientStorage.get(storageType.session,'dateFormat');
            return moment(date).format(this.dateFormat);
			// return OEUtils.DateUtils.format(date,this.dateFormat);
		},
		displayLiteral : function(lit) {
			return getLabel(lit);
		}
	}
